import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    accountDayList: () => {
        return HTTP.get('/account/history_account_today', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    accountIncomeList: () => {
        return HTTP.get('/account/ac_type_selection_income', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    accountExpensesList: () => {
        return HTTP.get('/account/ac_type_selection_expenses', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    creditorList: () => {
        return HTTP.get('/account/creditor_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    capitalList: () => {
        return HTTP.get('/account/capital_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    foodDeliveryList: () => {
        return HTTP.get('/account/food_delivery_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addAccountBook: (data) => {
        return HTTP.post('/account/create_ac_book',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editAccountBook: (id,data) => {
        return HTTP.post('/account/update_ac_book/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailAccountBook: (id) => {
        return HTTP.get('/account/edit_ac_book/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    accountHistoryList: (year,month) => {
        return HTTP.get('/account/history_account?year='+year+'&month='+month, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}